module.exports = __webpack_public_path__ + "static/media/result-success.290eec5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/result-success.svg
// module id = 1582
// module chunks = 0